<!-- Purchase Manager Landing Page -->
<div class="pm-landing-container">
  <!-- Header -->
  <div class="pm-header">
    <div class="pm-header-left">
      <div class="pm-header-icon">
        <i class="material-icons"
          style="color: #e6b401; font-size: 28px;">shopping_cart</i>
      </div>
      <div class="pm-header-text">
        <h1 class="pm-title">Purchase Manager</h1>
        <p class="pm-subtitle">Search multiple items, SKUs, or commodities instantly.</p>
      </div>
    </div>
    <div class="pm-header-right">
      <button class="pm-favorites-btn"
        (click)="toggleFavoritesModal()">
        <i class="material-icons">favorite</i>
        <span>Favourites</span>
      </button>
    </div>
  </div>

  <!-- Search Section -->
  <div class="pm-search-section">
    <div class="pm-search-box"
      [class.focused]="showSearchDropdown">
      <div class="pm-search-input-row">
        <i class="material-icons search-icon">search</i>
        <input type="text"
          #searchInput
          class="pm-search-input"
          [(ngModel)]="searchQuery"
          (input)="onSearchInput()"
          (focus)="showSearchDropdown = searchResults.length > 0"
          (blur)="onSearchBlur()"
          (keydown.enter)="onSearchSubmit()"
          placeholder="Search eg: 'Red Onion 50T', 'Potatoes Grade A'..." />
        <span class="pm-search-shortcut">Ctrl + K</span>
        <button class="pm-search-btn"
          (click)="onSearchNavigate()"
          [disabled]="searchTags.length === 0 && (!searchQuery || searchQuery.length < 2)">
          Search
          <span class="pm-search-count"
            *ngIf="searchTags.length > 0">({{ searchTags.length }})</span>
        </button>
      </div>

      <!-- Search Tags -->
      <div class="pm-search-tags"
        *ngIf="searchTags.length > 0">
        <span class="pm-tag"
          *ngFor="let tag of visibleTags">
          {{ tag.name }}
          <i class="material-icons pm-tag-close"
            (click)="removeSearchTag(tag)">close</i>
        </span>
        <span class="pm-tag-more"
          *ngIf="hiddenTagCount > 0 && !showAllTags"
          (click)="showAllTags = true"
          style="cursor:pointer">
          +{{ hiddenTagCount }} More
        </span>
        <span class="pm-tag-more"
          *ngIf="showAllTags && searchTags.length > 8"
          (click)="showAllTags = false"
          style="cursor:pointer">
          Show less
        </span>
      </div>
    </div>

    <!-- Search Dropdown -->
    <div class="pm-search-dropdown"
      *ngIf="showSearchDropdown">
      <div class="pm-search-loading"
        *ngIf="isSearching">
        <i class="material-icons spin">refresh</i>
        <span>Searching...</span>
      </div>

      <div class="pm-search-empty"
        *ngIf="!isSearching && searchResults.length === 0 && searchQuery.length >= 2">
        No results found for "{{ searchQuery }}"
      </div>

      <div class="pm-search-result"
        *ngFor="let result of searchResults"
        (mousedown)="addSearchTag(result)">
        <div class="result-name">{{ result.itemName || result.item_name || result.name }}</div>
        <div class="result-details"
          *ngIf="result.supplierName || result.supplier_name">
          <span class="result-supplier">{{ result.supplierName || result.supplier_name }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Auto-Fill Smart Cart Section -->
  <app-auto-fill-smart-cart [entityId]="selectedEntityId"
    (configChanged)="onSmartCartConfigChanged($event)">
  </app-auto-fill-smart-cart>

  <!-- Quick Add Section -->
  <div class="pm-quick-add">
    <h3 class="pm-section-label">Quick Add <i class="material-icons"
        style="font-size: 16px; vertical-align: middle; color: #000000;">flash_on</i></h3>
    <div class="pm-quick-add-pills">
      <button class="pm-pill"
        *ngFor="let category of quickAddCategories"
        [class.active]="category.active"
        (click)="onQuickAddClick(category)">
        <i class="material-icons">{{ category.icon }}</i>
        <span>{{ category.label }}</span>
        <span class="pill-count"
          *ngIf="category.count">({{ category.count }})</span>
        <i class="material-icons pill-close"
          *ngIf="category.active"
          (click)="dismissQuickAdd(category); $event.stopPropagation()">close</i>
      </button>
    </div>
  </div>

  <!-- Udaan Promotional Banner -->
  <div class="pm-udaan-banner">
    <img src="assets/images/udaan-promo-banner.png"
      alt="Udaan - Flat ₹500 OFF On First 5 Orders" />
  </div>

  <!-- Loading Overlay -->
  <div class="pm-loading"
    *ngIf="isLoading">
    <div class="pm-spinner"></div>
    <span>Loading items...</span>
  </div>

  <!-- Recent Searched Section -->
  <div class="pm-card-section"
    *ngIf="recentPurchases.length > 0 && !isLoading">
    <h3 class="pm-section-title">Recent Searched</h3>
    <div class="pm-card-scroll">
      <div class="pm-product-card"
        *ngFor="let item of recentPurchases">
        <div class="pm-card-image">
          <img [src]="item.imageUrl || 'assets/images/placeholder-product.svg'"
            [alt]="item.name"
            loading="lazy"
            onerror="this.src='assets/images/placeholder-product.svg'" />
        </div>
        <div class="pm-card-body">
          <h4 class="pm-card-name">{{ item.name }}</h4>
          <p class="pm-card-package">{{ item.packageInfo }}</p>
          <div class="pm-card-btn-row"
            *ngIf="isItemAdded(item)">
            <span class="pm-added-label"><i class="material-icons"
                style="font-size: 14px; vertical-align: middle;">check</i> Added</span>
            <button class="pm-remove-btn"
              (click)="removeFromSearch(item)"
              title="Remove from search">
              <i class="material-icons">delete_outline</i>
            </button>
          </div>
          <button class="pm-add-search-btn"
            *ngIf="!isItemAdded(item)"
            (click)="addToSearch(item)">
            Add to Search
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Most Searched Section -->
  <div class="pm-card-section"
    *ngIf="mostSearchedItems.length > 0 && !isLoading">
    <h3 class="pm-section-title">Most Searched</h3>
    <div class="pm-card-scroll">
      <div class="pm-product-card"
        *ngFor="let item of mostSearchedItems">
        <div class="pm-card-image">
          <img [src]="item.imageUrl || 'assets/images/placeholder-product.svg'"
            [alt]="item.name"
            loading="lazy"
            onerror="this.src='assets/images/placeholder-product.svg'" />
        </div>
        <div class="pm-card-body">
          <h4 class="pm-card-name">{{ item.name }}</h4>
          <p class="pm-card-package">{{ item.packageInfo }}</p>
          <div class="pm-card-btn-row"
            *ngIf="isItemAdded(item)">
            <span class="pm-added-label"><i class="material-icons"
                style="font-size: 14px; vertical-align: middle;">check</i> Added</span>
            <button class="pm-remove-btn"
              (click)="removeFromSearch(item)"
              title="Remove from search">
              <i class="material-icons">delete_outline</i>
            </button>
          </div>
          <button class="pm-add-search-btn"
            *ngIf="!isItemAdded(item)"
            (click)="addToSearch(item)">
            Add to Search
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Trending Near You Section -->
  <div class="pm-card-section"
    *ngIf="trendingItems.length > 0 && !isLoading">
    <h3 class="pm-section-title">Trending near you</h3>
    <div class="pm-card-scroll">
      <div class="pm-product-card"
        *ngFor="let item of trendingItems">
        <div class="pm-card-image">
          <img [src]="item.imageUrl || 'assets/images/placeholder-product.svg'"
            [alt]="item.name"
            loading="lazy"
            onerror="this.src='assets/images/placeholder-product.svg'" />
        </div>
        <div class="pm-card-body">
          <h4 class="pm-card-name">{{ item.name }}</h4>
          <p class="pm-card-package">{{ item.packageInfo }}</p>
          <div class="pm-card-btn-row"
            *ngIf="isItemAdded(item)">
            <span class="pm-added-label"><i class="material-icons"
                style="font-size: 14px; vertical-align: middle;">check</i> Added</span>
            <button class="pm-remove-btn"
              (click)="removeFromSearch(item)"
              title="Remove from search">
              <i class="material-icons">delete_outline</i>
            </button>
          </div>
          <button class="pm-add-search-btn"
            *ngIf="!isItemAdded(item)"
            (click)="addToSearch(item)">
            Add to Search
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty State -->
  <div class="pm-empty-state"
    *ngIf="!isLoading && recentPurchases.length === 0 && mostSearchedItems.length === 0 && trendingItems.length === 0">
    <i class="material-icons">shopping_basket</i>
    <h3>No items found</h3>
    <p>Start by searching for items or use Quick Add to get started.</p>
  </div>

  <!-- Favorites Modal -->
  <div class="pm-modal-overlay"
    *ngIf="showFavoritesModal"
    (click)="toggleFavoritesModal()">
    <div class="pm-modal"
      (click)="$event.stopPropagation()">
      <div class="pm-modal-header">
        <div class="pm-modal-title">
          <i class="material-icons"
            style="color:#ef4444">favorite</i>
          <h3>My Favourites</h3>
          <span class="pm-modal-count"
            *ngIf="favoriteItemsList.length > 0">{{ favoriteItemsList.length }}</span>
        </div>
        <button class="pm-modal-close"
          (click)="toggleFavoritesModal()">
          <i class="material-icons">close</i>
        </button>
      </div>

      <!-- Search within favorites -->
      <div class="pm-modal-search">
        <i class="material-icons">search</i>
        <input type="text"
          [(ngModel)]="searchFavoriteTerm"
          placeholder="Search favourites..." />
      </div>

      <!-- Loading -->
      <div class="pm-modal-loading"
        *ngIf="isFavoritesLoading">
        <div class="pm-spinner"></div>
        <span>Loading favourites...</span>
      </div>

      <!-- Favorite Items List -->
      <div class="pm-modal-body"
        *ngIf="!isFavoritesLoading">
        <div class="pm-fav-item"
          *ngFor="let fav of filteredFavorites">
          <div class="pm-fav-info">
            <i class="material-icons pm-fav-icon">inventory_2</i>
            <span class="pm-fav-name">{{ fav.item_name || fav.itemName || fav.name }}</span>
          </div>
          <div class="pm-fav-actions">
            <button class="pm-fav-search-btn"
              (click)="searchFavoriteItem(fav)"
              title="Search this item">
              <i class="material-icons">search</i>
            </button>
            <button class="pm-fav-remove-btn"
              (click)="removeFavoriteByName(fav.item_name || fav.itemName || fav.name)"
              title="Remove from favourites">
              <i class="material-icons">delete_outline</i>
            </button>
          </div>
        </div>

        <!-- Empty State -->
        <div class="pm-modal-empty"
          *ngIf="filteredFavorites.length === 0 && !searchFavoriteTerm">
          <i class="material-icons">favorite_border</i>
          <p>No favourite items yet.</p>
          <span>Add items to favourites from search results.</span>
        </div>

        <!-- No search results -->
        <div class="pm-modal-empty"
          *ngIf="filteredFavorites.length === 0 && searchFavoriteTerm">
          <i class="material-icons">search_off</i>
          <p>No match found for "{{ searchFavoriteTerm }}"</p>
        </div>
      </div>
    </div>
  </div>

</div>
<app-profile-setup-modal></app-profile-setup-modal>